// frontend/src/api/pingClient.ts
import { apiFetch } from "./baseClient";

export async function notifyProjectActivity(projectId: number): Promise<void> {
  await apiFetch("/api/projects/activity", {
    method: "POST",
    body: { project_id: projectId } as any,
  });
}